import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './store/store.js'
import VueI18n from 'vue-i18n'
import {defaultLocale, languages} from './i18n/index.js'
import Toasted from 'vue-toasted';

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import "@nuxeo/nuxeo-elements/nuxeo-page-provider"
import "@nuxeo/nuxeo-elements/nuxeo-operation"

const requireComponent = require.context(
    // The relative path of the components folder
    './components',
    // Whether or not to look in subfolders
    true,
    // The regular expression used to match base component filenames
    /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName);

    // Get PascalCase name of component
    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    );


    // Register component globally
    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
    )
});

Vue.use(VueI18n);
const messages = Object.assign(languages);

Vue.use(Toasted);

Vue.config.productionTip = false;

let i18n = new VueI18n({
    locale: defaultLocale,
    messages
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
